import moment from 'moment-timezone';
import { FONT_FAMILY } from '@utils/constants';
import { TOOLTIP_LABEL_FORMAT } from '@components/common/Charts/utils';
import humanizeUtil from '@utils/humanizeUtil';
import { getMetricUnitByKey, getMetricDisplayName } from '@utils/metrics';
import { DEFAULT_FILTER_COLOR } from '@src/utils/colorPalette';

export const formatMetricDataForChart = ({
  chartData,
  metricKey,
  color = DEFAULT_FILTER_COLOR,
}) => {
  const tooltipFormatter = (params) => {
    const unit = getMetricUnitByKey({ metricKey });
    const value = params[0].data;
    const { humanizedNumber, humanizedUnit } = humanizeUtil(value[1], metricKey, unit);
    const metricDisplayName = getMetricDisplayName({ metricKey });
    const xVal = moment(value[0]).format(TOOLTIP_LABEL_FORMAT);
    return `${xVal}<br/>${metricDisplayName} - <b>${humanizedNumber} ${humanizedUnit}</b>`;
  };

  const option: any = {
    _viewType: 'timeseries',
    color: [color],
    grid: {
      left: 5,
      bottom: 5,
      right: 5,
      top: 5,
    },
    tooltip: {
      trigger: 'axis',
      formatter: tooltipFormatter,
      font: FONT_FAMILY,
      appendToBody: true,
      className: 'echarts-tooltip',
    },
    xAxis: {
      type: 'time',
      show: false,
    },
    yAxis: {
      type: 'value',
      show: false,
    },
    series: [
      {
        data: chartData,
        type: 'line',
        showSymbol: false,
        areaStyle: {
          opacity: 0.1,
          color,
        },
        lineStyle: {
          width: 1,
        },
      },
    ],
  };
  return option;
};

export const getHumanizedValueString = (data, metricKey) => {
  const unit = getMetricUnitByKey({ metricKey });
  const { humanizedNumber, humanizedUnit } = humanizeUtil(data[metricKey] || 0, metricKey, unit);
  return `${humanizedNumber} ${humanizedUnit}`;
};
